<template>
  <v-autocomplete :value="value"
                  :color="color"
                  :placeholder="$t('login.country')"
                  :solo="solo"
                  :outlined="outlined"
                  style="font-size: 13px"
                  :items="countries"
                  :filter="searchCountry"
                  item-text="country"
                  hide-details
                  no-data-text="No hay resultados"
                  return-object
                  ref="countryPicker"
                  @change="changeCountry">
      <div slot="prepend-inner">
        <img style="margin-top: 5px" class="iti-flag" :class="[value.code]">
      </div>
  </v-autocomplete>
</template>

<script>
import countries from '@/libs/countries'
export default {
  created () {
    this.findUserCountry()
    /* this.axios.get('https://ipinfo.io/json')
      .then(response => {
        this.$emit('input', this.country = countries.find(element => {
          return element.code === response.data.country.toLowerCase()
        }))
      })
      .catch(() => {
        this.$emit('input', this.country = countries.find(element => {
          return element.code === 'co'
        }))
      }) */
  },
  data () {
    return {
      countries: countries
    }
  },
  methods: {
    changeCountry (value) {
      this.$emit('input', value)
    },
    findUserCountry () {
      if (this.value.code) return
      this.$emit('input', this.country = countries.find(element => {
        return element.code === 'co'
      }))
    },
    searchCountry (item, queryText, itemText) {
      const country = item.country.toLowerCase()
      const number = item.number.toLowerCase()
      const searchText = queryText.toLowerCase()

      return country.indexOf(searchText) > -1 ||
          number.indexOf(searchText) > -1
    }
  },
  props: ['color', 'outlined', 'value', 'solo']
}
</script>
